export interface HorizontalBarItem {
  key: string;
  label: string;
  value: number;
  icon?: string;
}

interface HorizontalBarsProps {
  items: HorizontalBarItem[];
  valueFormatter: (value: number) => string;
  /** Nom du token de couleur StyleSystem, ex : "primary-500". */
  token?: string;
  emptyLabel: string;
}

/**
 * Barres horizontales comparatives (répartitions), responsive et accessibles.
 */
export default function HorizontalBars({
  items,
  valueFormatter,
  token = "primary-500",
  emptyLabel,
}: HorizontalBarsProps) {
  const max = items.reduce((acc, item) => Math.max(acc, item.value), 0);

  return (
    <div className="flex flex-col gap-3.5">
      {items.length === 0 && <p className="text-sm text-foreground-500">{emptyLabel}</p>}
      {items.map((item) => {
        const pct = max > 0 ? Math.round((item.value / max) * 100) : 0;
        return (
          <div key={item.key} className="flex flex-col gap-1.5">
            <div className="flex items-center justify-between gap-3">
              <span className="flex min-w-0 items-center gap-2 text-sm text-foreground-800">
                {item.icon && (
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-500">
                    <i className={`${item.icon} text-sm`} aria-hidden="true" />
                  </span>
                )}
                <span className="truncate">{item.label}</span>
              </span>
              <span className="shrink-0 text-sm font-label font-medium text-foreground-950">
                {valueFormatter(item.value)}
              </span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-100">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{ width: `${pct}%`, background: `oklch(var(--${token}))` }}
                aria-hidden="true"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}